import axios from 'axios';

/**
 * The web access token lives only here, in memory. It is never written to localStorage or
 * sessionStorage, so an XSS payload cannot read a long-lived credential out of storage; the
 * long-lived part is the HttpOnly refresh cookie, which script cannot see.
 */
let accessToken: string | null = null;
const listeners = new Set<(token: string | null) => void>();

export const getToken = (): string | null => accessToken;

export const setToken = (token: string | null): void => {
    accessToken = token;
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
    listeners.forEach((listener) => listener(token));
};

export const clearToken = (): void => setToken(null);

export const subscribe = (listener: (token: string | null) => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};
